import React from 'react'

import { Example } from '@/_private/storybook'

import { Image } from '../..'

export const ImageExample = () => (
  <Example height="100px">
    <Image src="https://images.pexels.com/photos/414612/pexels-photo-414612.jpeg" />
  </Example>
)
